import React, { useContext, useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import { Badge } from 'reactstrap';
import { UserContext } from '../../contexts/UserContext';
import useOnScreen from '../../custom-hooks/useIsVisibleOnScreen';
import useUpdateAlert from '../../custom-hooks/useUpdateAlert';
import { SrxApi } from '../../api/SrxApi';
import { toast } from 'react-toastify';
import { getActionLabel, getActionBadgeColor, getActionSentTimeMs, isActionFromCurrentUser } from './actionUtils';

const ActionMessage = ({ action, i, alert, category }) => {
    const { user } = useContext(UserContext);
    const [, setTick] = useState(0);
    const messageRef = useRef(null);
    const isVisible = useOnScreen(messageRef);
    const { updateMessageReadStatus } = useUpdateAlert();

    useEffect(() => {
        const id = setInterval(() => setTick((t) => t + 1), 60_000);
        return () => clearInterval(id);
    }, []);

    const changeActionMessageReadStatus = async (status) => {
        SrxApi.post('/requestaction_readByFaci', {
            requestActionID: action.requestActionID,
            readByFaci: status,
        })
            .then((res) => {
                updateMessageReadStatus(status, action, alert, category);
            })
            .catch((err) => toast.error('Error updating read status'));
    };

    useEffect(() => {
        if (isVisible) {
            if (action.action.toLowerCase() === 'reply' && !action.readByFaci) {
                changeActionMessageReadStatus(true);
            }
        }
    }, [isVisible]);

    function difference2Parts(date) {
        const nowMs = Date.now();
        const dateMs = date instanceof Date ? date.getTime() : new Date(date).getTime();
        const secs = Math.floor(Math.abs(nowMs - dateMs) / 1000);
        const mins = Math.floor(secs / 60);
        const hours = Math.floor(mins / 60);
        const days = Math.floor(hours / 24);

        return {
            days,
            hours: hours % 24,
            hoursTotal: hours,
            minutesTotal: mins,
            minutes: mins % 60,
            seconds: secs % 60,
            secondsTotal: secs,
        };
    }

    function showDifferenceInTime(date) {
        const difference = difference2Parts(date);
        if (difference.days) return difference.days > 1 ? difference.days + ' days ago' : difference.days + ' day ago';
        if (difference.hours) return difference.hours > 1 ? difference.hours + ' hours ago' : difference.hours + ' hour ago';
        if (difference.minutes) return difference.minutes > 1 ? difference.minutes + ' minutes ago' : difference.minutes + ' minute ago';
        return 'Just now';
    }

    const label = getActionLabel(action.action);
    const badgeColor = getActionBadgeColor(action.action);
    const sentTimeMs = getActionSentTimeMs(action);
    const sentTimeText = sentTimeMs ? new Date(sentTimeMs).toLocaleString() : 'Unknown time';

    return (
        <div ref={messageRef}>
            <li className={classNames('clearfix', { odd: !isActionFromCurrentUser(action, user) })}>
                <div className="chat-avatar">
                    <svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 3 24 24">
                        <path
                            fill="currentColor"
                            d="M6 17c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1H6m9-9a3 3 0 0 1-3 3a3 3 0 0 1-3-3a3 3 0 0 1 3-3a3 3 0 0 1 3 3M3 5v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2Z"
                        />
                    </svg>
                </div>
                <div className="conversation-text">
                    <div className="ctext-wrap">
                        <i>{action.requestedBy}</i>
                        <p>{action.actionComment}</p>
                        {label && (
                            <h5 className="mt-1 mb-0">
                                <Badge className={'bg-' + badgeColor}>
                                    {label}
                                </Badge>
                            </h5>
                        )}
                    </div>
                    <div className="action-message-time">
                        {showDifferenceInTime(sentTimeMs)} ~ {sentTimeText}
                    </div>
                </div>
            </li>
        </div>
    );
};

export default ActionMessage;
